import ContentRegistryGrid from '@/components/content-registry-grid/content-registry-grid';
import RegistryFilterOptionDisplay from '@/components/learing-registry/registry-filter-option-display/registry-filter-option-display';
import RegistrySearchFilter from '@/components/learing-registry/registry-search-filter/registry-search-filter';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { appConfigService } from '@/providers/services/app/app-config';
import { sessionService } from '@/providers/services/auth/session';
import { PERMISSION_CHECK } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'tool-registry',
    components: {
        'registry-search-filter': RegistrySearchFilter,
        'registry-filter-option-display': RegistryFilterOptionDisplay,
        'content-registry-grid': ContentRegistryGrid,
    },
})

export default class ToolRegistryComponent extends Vue {

    // ----------------------------------------------------------------------------
    // Properties

    private tableFields: any = [
        {
            label: 'Product Name',
            key: 'name',
            tdClass: 'product-column',
            thClass: 'product-head',
        },
        {
            label: 'Description',
            key: 'description',
        },
        {
            label: 'Subject',
            key: 'subjectData',
        },
        {
            label: 'Grade Range',
            key: 'grades',
        },
        {
            label: 'Audience',
            key: 'audience',
        },
    ];

    private permissonCheck = PERMISSION_CHECK;

    private registryList: any = [];

    private searchTerms: string = '';

    private offset: number = 0;

    private limit: number = 12;

    private perPage: number = 10;

    private totalRowCounts: number = 10;

    private currentPage: number = 1;

    private isLoading: boolean = false;

    private selectedFilter: any = {};

    @Prop()
    private filterData: any;

    @Prop()
    private terms!: string;

    private get providersList() {
        return appConfigService.getProvidersList() || [];
    }

    private rawFilterOptionList: any = {};


    // --------------------------------------------------------------------------
    // Actions

    public onSelectPage(pageNumber: number) {
        window.scrollTo(0, 0);
        this.currentPage = pageNumber;
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.loadData();
    }

    public onSearch(searchTerms: string) {
        this.searchTerms = searchTerms;
        this.$emit('onSearch', searchTerms);
        this.resetProperties();
        this.loadData();
    }

    private addNewTool() {
        this.$router.push('/partner-catalog/tool-registry/add-tool');
    }

    private onSelectTool(toolData: any) {
        this.$emit('onSelectTool', toolData);
        this.$router.push('/partner-catalog/tool-registry/edit-tool');
    }

    private onApplyFilter(filterList: any, filterOptionList: any) {
        this.$emit('onApplyFilter', filterList);
        this.selectedFilter = filterList;
        this.rawFilterOptionList = filterOptionList;
        this.resetProperties();
        this.loadData();
    }

    // ----------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.selectedFilter = this.filterData;
        this.searchTerms = this.terms;
        this.loadData();
        if (this.$access.isContentProvider) {
            this.additionalColumn();
        }
    }


    // --------------------------------------------------------------------------------------
    // Methods

    private loadData() {
        this.isLoading = true;
        if (this.$access.isHavingPermisson(this.permissonCheck.createTool)) {
            this.fethToolRegistry();
        } else {
            this.fetchSubscribedTool();
        }
    }

    private fethToolRegistry() {
        const selectedFilter = this.selectedFilter;
        const session: any = sessionService.getSession();
        const params: any = {
            offset: this.offset,
            limit: this.limit,
            search_terms: this.searchTerms,
            // tenant: session.tenant!.tenant_id,
        };
        if (Object.keys(selectedFilter).length) {
            this.parseFilterBody(params);
        }
        learningRegistryAPI.fetchToolRegistryList(params).then((registryList: any) => {
            if (this.$access.isContentProvider) {
                this.registryList = this.filterContentProviderProduct(registryList.providers);
                this.totalRowCounts = this.registryList.length;
            } else {
                this.registryList = registryList.providers;
                this.totalRowCounts = registryList.totalCount;
            }
            this.isLoading = false;
        });
    }

    private fetchSubscribedTool() {
        const selectedFilter = this.selectedFilter;
        const session: any = sessionService.getSession();
        const params = {
            offset: this.offset,
            limit: this.limit,
            registry_type: 'tool_registry',
            search_terms: this.searchTerms,
            // tenant: session.tenant!.tenant_id,
        };
        if (Object.keys(selectedFilter).length) {
            this.parseFilterBody(params);
        }
        learningRegistryAPI.fetchSubscribedToolRegistryList(params).then((registryList: any) => {
            const registryData = registryList.subscribedTools.filter((item: any) => item.subscribeStatus === 'active');
            if (this.$access.isContentProvider) {
                this.registryList = this.filterContentProviderProduct(registryData);
                this.totalRowCounts = this.registryList.length;
            } else {
                this.registryList = registryData;
                this.totalRowCounts = registryList.totalCount;
            }
            this.isLoading = false;
        });
    }

    private resetProperties() {
        this.registryList = [];
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
    }

    private parseFilterBody(params: any) {
        const {category, audience, subject, grades, toolCateogry} = this.selectedFilter;
        params.category = category.length ? category.toString() : null;
        params.subject = subject.length ? subject.toString() : null;
        params.grades = grades.length ? grades.toString() : null;
        params.audience = audience.length ? audience.toString() : null;
        params.tool_category = toolCateogry.length ? toolCateogry.toString() : null;
    }

    private filterContentProviderProduct(content: any) {
        const contentList = content.filter((item: any) => this.providersList.indexOf(item.name) !== -1);
        return contentList;
    }

    private additionalColumn() {
        const tableFields = this.tableFields;
        tableFields.push({
            label: 'Action',
            key: 'action',
        });
    }

    private removeSelectedItem(item: any) {
        const childElem: any = this.$refs.searchfilter;
        childElem.removeSelectedItem(item);
    }

    private removeSearchText() {
        const childElem: any = this.$refs.searchfilter;
        childElem.removeSearchText();
    }
}
